export default __webpack_public_path__ + "static/media/ico-bug-score-high.07b71d11.svg";